'use client'

import { useEffect } from 'react'

type UseSetTimeoutProps = {
  callback: () => void
  delay: number
  condition: boolean
}

export const useSetTimeout = ({ callback = () => {}, delay, condition }: UseSetTimeoutProps) => {
  useEffect(() => {
    if (condition) {
      const timer = setTimeout(callback, delay)
      return () => clearTimeout(timer)
    }
  }, [callback, delay, condition])
}
